// removed by extract-text-webpack-plugin
module.exports = {"modalform":"modalform__3NFbq","submit":"submit__3mol6"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/DetailView/coms/ImportOTAAModal/styles.scss
// module id = 2207
// module chunks = 1